/*
|--------------------------------------------------------------------------
| Data: Validator
|--------------------------------------------------------------------------
*/
/**
 * Checks items for a required number that must pass an "item" validation method. If all passes, it'll return the first position of the first item that passed validation. (ie. Check to see if there are 2 stories with images, if it there are, it'll return the position of the first story with an image.
 * @namespace
 * @param {object} options
 * @param {array} options.data - array of item objects
 * @param {integer} options.required - number of items that must match validation
 * @param {string} options.validationMethod - a validation method from within the __gh__webApp.data.validate.item object.
 */
__gh__webApp.data.itemValidator = function(options){
	var data 				= (options.data) 				? options.data 				: {},
		required			= (options.required)			? options.required 			: 0,
		validationMethod	= (options.validationMethod)	? options.validationMethod	: "",
		count 				= 0,
		firstPosition 		= false;

	for (var i = 0; i < data.length; i++) {
		if (__gh__webApp.data.validate.item[validationMethod](data[i])){
			count++;
			if (count == 1) {
				firstPosition = i;
			}
			if (count==required){
				return firstPosition;
			}
		}
	}
	return false;
};
